import { createRoot } from "react-dom/client";
import "./i18n";

import App from "./app";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- safe
const root = createRoot(document.getElementById("root")!);
root.render(<App />);
